import React from 'react';
import { withRouter } from 'react-router';

// stores & services
import ConfirmDetailsStore from '../stores/ConfirmDetailsStore.js';
import ContentService from '../services/ContentService';
import Transitions from '../core/Transitions';
import ApplicationActions from '../actions/ApplicationActions.js';
import ConfirmDetailsActions from '../actions/ConfirmDetailsActions.js';
import ApplicationConstants from '../constants/ApplicationConstants';
import ApplicationStore from '../stores/ApplicationStore';
import DeclarationStore from '../stores/DeclarationStore.js';

// components
import autoBind from 'react-autobind';
import NavigationBar from './NavigationBar.jsx';
import SimpleReview from './ConfirmDetails/SimpleReview.jsx';
import InvestmentAllocation from './ConfirmDetails/InvestmentAllocation/InvestmentAllocation.jsx';
import RegularInvestmentPlanReview from './ConfirmDetails/RegularInvestmentPlan/RegularInvestmentPlanReview.jsx';
import FundingYourProductReview from './ConfirmDetails/FundingYourProduct/FundingYourProductReview.jsx';
import InSpecieTransferReview from './ConfirmDetails/InSpecieTransfer/InSpecieTransferReview.jsx';
import SimpleMessageReview from './ConfirmDetails/SimpleMessageReview.jsx';
import IncomeDistributionReview from './ConfirmDetails/IncomeDistribution/IncomeDistributionReview.jsx';
import RepeatingSectionSimpleReview from './ConfirmDetails/RepeatingSectionSimpleReview.jsx';
import PensionPaymentReview from './ConfirmDetails/PensionPayment/PensionPaymentReview.jsx';
import Footer from './Footer.jsx';
import Products from './../utils/Products.js';
import FooterUtil from './../utils/FooterHelper.js';
import DownloadFormsHelper from '../utils/DownloadFormsHelper.js';
import UserNotification from './Common/UserNotification.jsx';
import DigitalConsentEligibilityHelper from '../utils/DigitalConsentEligibilityHelper.js';
import IDVerificationActions from '../actions/IDVerificationActions.js';
import { Eligibility } from '../constants/IDVerificationConstants';
import _ from 'lodash';
import ApplicationHelper from '../utils/ApplicationHelper.js';
import OmnitureTracking from '../utils/OmnitureTracking.js';
import InvestmentOptionStore from '../stores/InvestmentOptionStore';

function getConfirmDetailsState() {
    return {
        product: ConfirmDetailsStore.getProduct(),
        onlineAccessInfo: ConfirmDetailsStore.getOnlineAccessInfo(),
        adviserAuthority: ConfirmDetailsStore.getAdviserAuthorityInfo(),
        adviserAttestation: ConfirmDetailsStore.getAdviserAttestationInfo(),
        yourDetails: ConfirmDetailsStore.getYourDetails(),
        autoRebalancing: ConfirmDetailsStore.getAutoBalancingInfo(),
        portfolioRebate: ConfirmDetailsStore.getportfolioRebateInfo(),
        adviserFees: ConfirmDetailsStore.getAdviserFees(),
        investmentAllocation: ConfirmDetailsStore.getInvestmentAllocation(),
        regularInvestmentPlan: ConfirmDetailsStore.getRegularInvestmentPlan(),
        regularInvestmentPlanInvestOption: ConfirmDetailsStore.getRegularInvestmentPlantInvestOption(),
        fundingYourProduct: ConfirmDetailsStore.getFundingYourProduct(),
        fundingYourProductTotal: ConfirmDetailsStore.getFundingYourProductTotal(),
        fundingYourProductBankingDetails: ConfirmDetailsStore.getFundingYourProductBankingDetails(),
        fundingYourProductTaxClaim: ConfirmDetailsStore.getFundingYourProductTaxClaim(),
        fundingYourProductHasTermDeposit: ConfirmDetailsStore.getFundingYourProductHasTermDeposit(),
        sectionVisibility: ConfirmDetailsStore.getSectionVisibility(),
        content: ContentService.getContent(),
        clientIdentificationMode: ApplicationStore.getClientIdentificationMode(),
        accountSettings: ConfirmDetailsStore.getAccountSettings(),
        superFirstTransfer: ConfirmDetailsStore.getSuperFirstTransferInfo(),
        inSpecieTransfer: ConfirmDetailsStore.getInSpecieTransferInfo(),
        annuityQuoteUrl: ConfirmDetailsStore.getAnnuityQuoteUrl(),
        beneficiaryDetails: ConfirmDetailsStore.getBeneficiaryDetails(),
        pensionType: ConfirmDetailsStore.getPensionTypeInfo(),
        specialRequestsInfo: ConfirmDetailsStore.getSpecialRequestsInfo(),
        showMoreMenu: ConfirmDetailsStore.getShowHideMore(),
        accountType: ConfirmDetailsStore.getAccountType(),
        pensionPayment: ConfirmDetailsStore.getPensionPayment(),
        pensionPaymentInvestOption: ConfirmDetailsStore.getPensionPaymentInvestOption(),
        application: ConfirmDetailsStore.getApplication(),
        workItem: ConfirmDetailsStore.getWorkItem(),
        accountNumber: ConfirmDetailsStore.getAccountNumber(),
        hasSubmitFailed: ConfirmDetailsStore.getHasSubmitFailed(),
        incomeDistribution: ConfirmDetailsStore.getIncomeDistribution(),
        showDownloadMenu: ConfirmDetailsStore.getShowDownloadMenu(),
        formsToDownload: ConfirmDetailsStore.getFormsToDownload(),
        enableDownloadButton: ConfirmDetailsStore.getEnableDownloadButton(),
        downloadInProgress: ConfirmDetailsStore.getDownloadInProgress(),
        selectedForms: ConfirmDetailsStore.getSelectedForms(),
        accountTypeCode: ConfirmDetailsStore.getAccountTypeCode(),
        readyForDownload: ConfirmDetailsStore.getReadyForDownload(),
        downloadedForms: ConfirmDetailsStore.getDownloadedForms(),
        formDownloaded: ConfirmDetailsStore.getIsFormsDownloaded(),
        downloadFormsFailed: ConfirmDetailsStore.getDownloadFormsFailed(),
        canContinue: ConfirmDetailsStore.canContinue(),
        isInSpecieScenarioValid: ConfirmDetailsStore.isInSpecieScenarioValid(),
        isInSpecieScenarioNotificationClosed: ConfirmDetailsStore.getIsInSpecieScenarioNotificationClosed(),
        isOnlineAccessVisible: ConfirmDetailsStore.showOnlineAccessSection(),
        waitingForDigitalConsentKillSwitch: DeclarationStore.getWaitingForDigitalConsentKillSwitch(),
        digitalConsentCheckEnabled: DeclarationStore.getDigitalConsentCheckEnabled(),
        eligibility: DeclarationStore.getEligibility(),
        formModel: DeclarationStore.getFormModel(),
        isPreRetirement: InvestmentOptionStore.getIsPreRetirement(),
        isEmulation: ApplicationStore.isEmulation()
    };
}

class ConfirmDetails extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = getConfirmDetailsState();
    }

    closeInvalidInSpecieScenarioNotification() {
        ConfirmDetailsActions.closeInspecieManualScenarioNotification();
    }

    _renderConfirmationSections() {
        let inSpecieTransfer = null;
        const SectionId = ApplicationConstants.SectionId;
        if (this.state.sectionVisibility.inSpecieTransfer && this.state.inSpecieTransfer && this.state.inSpecieTransfer.items && this.state.inSpecieTransfer.items.length > 0) {
            if (this.state.inSpecieTransfer.setupInSpecieTransfer) {
                inSpecieTransfer = <InSpecieTransferReview sectionId={SectionId.inSpecieTransfer} handlePencilClick={this.goBackToApplicationForm} 
                sectionName={this.state.content.inSpecieTransfer.sectionHeader} sectionMessage={this.state.content.inSpecieTransfer.sectionMessage} 
                items={this.state.inSpecieTransfer.items} externalAccountsAllocatedAsPerQuestion={this.state.inSpecieTransfer.externalAccountsAllocatedAsPerQuestion}
                externalAccountsAllocatedAsPerFunds={this.state.inSpecieTransfer.externalAccountsAllocatedAsPerFunds} />;
            } else {
                inSpecieTransfer = <SimpleReview sectionId={SectionId.inSpecieTransfer} handlePencilClick={this.goBackToApplicationForm} sectionName={this.state.content.inSpecieTransfer.sectionHeader} items={this.state.inSpecieTransfer.items} />
            }
        }

        // Portfolio Rebate - Investments Account Type Configurations
        let portfolioRebateHeader = this.state.content.portfolioRebate.sectionHeader,
            ripSectionMessage = this.state.content.regularInvestmentPlan.sectionMessage;

        if (Products.isInvestment(this.state.product.value)) {
            portfolioRebateHeader = this.state.content.portfolioRebate.investmentSectionHeader;
            ripSectionMessage = this.state.content.regularInvestmentPlan.sectionMessageInvestment;
        }

        return (<div className="main">
            { this.state.sectionVisibility.accountType ? <SimpleReview sectionId={SectionId.accountType} handlePencilClick={this.goBackToApplicationForm} sectionName={this.state.content.accountType.sectionHeader} items={this.state.accountType} /> : null }
            { this.state.sectionVisibility.yourDetails ? <RepeatingSectionSimpleReview sectionId={SectionId.yourDetails} handlePencilClick={this.goBackToApplicationForm} sectionName={this.state.content.yourDetails.sectionHeader} items={this.state.yourDetails} /> : null }
            { this.state.sectionVisibility.pensionType ? <SimpleMessageReview sectionId={SectionId.pensionType} handlePencilClick={this.goBackToApplicationForm} sectionName={this.state.content.pensionType.sectionHeader} items={this.state.content.pensionType.benefitItemText} value={this.state.pensionType} /> : null }
            { this.state.sectionVisibility.accountSettings ? <RepeatingSectionSimpleReview sectionId={SectionId.accountSettings} handlePencilClick={this.goBackToApplicationForm} sectionName={this.state.content.accountSettings.sectionHeader} sectionLabel="Annuity payment credited to the following account" items={this.state.accountSettings} /> : null }
            { this.state.sectionVisibility.fundingYourProduct ? <FundingYourProductReview sectionId={SectionId.fundingYourProduct} handlePencilClick={this.goBackToApplicationForm} sectionName={this.state.content.fundingYourProduct[this.state.product.value].sectionHeader} sectionMessage={this.state.content.fundingYourProduct[this.state.product.value].sectionMessage} items={this.state.fundingYourProduct} total={this.state.fundingYourProductTotal} bankAccountDetails={this.state.fundingYourProductBankingDetails} sectionParagraph={this.state.content.fundingYourProduct[this.state.product.value].sectionParagraph} hasTaxClaim={this.state.fundingYourProductTaxClaim} hasTermDeposit={this.state.fundingYourProductHasTermDeposit} productId={this.state.product.value} taxDeductionMessage={this.state.content.fundingYourProduct.confirmTaxDeductionMessage} /> : null }
            { inSpecieTransfer }
            { this.state.sectionVisibility.superFirstTransfer && this.state.superFirstTransfer.showSection ? <SimpleReview sectionId={SectionId.superFirstTransfer} handlePencilClick={this.goBackToApplicationForm} sectionName={this.state.content.superFirstTransfer.sectionHeader} items={this.state.superFirstTransfer.items} endLabel={this.state.superFirstTransfer.sftInlineMessageRollover} /> : null}
            { this.state.sectionVisibility.investmentAllocation && this.state.isInSpecieScenarioValid ? <InvestmentAllocation sectionId={SectionId.investmentAllocation} handlePencilClick={this.goBackToApplicationForm} inSpecieData={this.state.investmentAllocation.inSpecieData} sectionName={this.state.content.investmentAllocation.sectionHeader} investmentOptions={this.state.investmentAllocation.investmentOptions} allocations={this.state.investmentAllocation.allocations} investmentOptionsExternalOnly={this.state.investmentAllocation.investmentOptionsExternalOnly} allocationsExternalOnly={this.state.investmentAllocation.allocationsExternalOnly} content={this.state.content.investmentAllocation.confirmDetails} hasAllocations={this.state.investmentAllocation.hasAllocations} inSpecieNotification={this.state.investmentAllocation.inSpecieNotification} assetAllocationNotification={this.state.investmentAllocation.assetAllocationNotification} aggregatedAllocationsForPieChart={this.state.investmentAllocation.aggregatedAllocationsForPieChart} investmentOptionsTotalAmount={this.state.investmentAllocation.investmentOptionsTotalAmount} investmentOptionsExternalOnlyAmount={this.state.investmentAllocation.investmentOptionsExternalOnlyAmount} isPensionInSpecieTransfer={this.state.investmentAllocation.isPensionInSpecieTransfer} isConsolidatedTd={this.state.investmentAllocation.isConsolidatedTd} managedAccountName={this.state.investmentAllocation.managedAccountName} isFirstRateCashNonAutoRebalancing={this.state.investmentAllocation.isFirstRateCashNonAutoRebalancing} productId={this.state.product.value} isPreRetirement={this.state.isPreRetirement}/> : null }
            { this.state.sectionVisibility.pensionPayment ? <PensionPaymentReview sectionId={SectionId.pensionPayment} handlePencilClick={this.goBackToApplicationForm} sectionName={this.state.content.pensionPayment.sectionHeader} items={this.state.pensionPayment} investOptionItems={this.state.pensionPaymentInvestOption} /> : null }
            { this.state.sectionVisibility.beneficiaryDetails ? <SimpleReview sectionId={SectionId.beneficiaryDetails} handlePencilClick={this.goBackToApplicationForm} sectionName={this.state.content.beneficiaryDetails.sectionHeader} items={this.state.beneficiaryDetails} /> : null }
            { this.state.sectionVisibility.regularInvestmentPlan ? <RegularInvestmentPlanReview sectionId={SectionId.regularInvestmentPlan} handlePencilClick={this.goBackToApplicationForm} sectionName={this.state.content.regularInvestmentPlan.sectionHeader} sectionMessage={ripSectionMessage} items={this.state.regularInvestmentPlan} investOptionItems={this.state.regularInvestmentPlanInvestOption} /> : null }
            { this.state.sectionVisibility.incomeDistribution ? <IncomeDistributionReview content={this.state.content.incomeDistribution} sectionId={SectionId.incomeDistribution} handlePencilClick={this.goBackToApplicationForm} data={this.state.incomeDistribution} /> : null }
            { this.state.sectionVisibility.autoRebalancing ? <SimpleReview sectionId={SectionId.autoRebalancing} handlePencilClick={this.goBackToApplicationForm} sectionName={this.state.content.autoRebalancing.sectionHeader} items={this.state.autoRebalancing} /> : null }
            { this.state.sectionVisibility.portfolioRebate ? <SimpleReview sectionId={SectionId.portfolioRebate} handlePencilClick={this.goBackToApplicationForm} sectionName={portfolioRebateHeader} items={this.state.portfolioRebate} /> : null }
            { this.state.sectionVisibility.adviserAuthority ? <SimpleReview sectionId={SectionId.adviserAuthority} handlePencilClick={this.goBackToApplicationForm} sectionName={this.state.content.adviserAuthority.sectionHeader} items={this.state.adviserAuthority} /> : null }
            { this.state.sectionVisibility.adviserAttestation ? <SimpleReview sectionId={SectionId.adviserAttestation} handlePencilClick={this.goBackToApplicationForm} sectionName={this.state.content.adviserAttestation.sectionHeader} items={this.state.adviserAttestation} /> : null }
            { (this.state.sectionVisibility.onlineAccess && this.state.isOnlineAccessVisible) ? <RepeatingSectionSimpleReview sectionId={SectionId.onlineAccess} handlePencilClick={this.goBackToApplicationForm} sectionName={this.state.content.onlineAccess.sectionHeader} items={this.state.onlineAccessInfo} /> : null }
            { (this.state.sectionVisibility.specialRequests && this.state.specialRequestsInfo !== '') ? <SimpleMessageReview sectionId={SectionId.specialRequests} handlePencilClick={this.goBackToApplicationForm} sectionName={this.state.content.specialRequests.reviewHeader} value={this.state.specialRequestsInfo} /> : null }
        </div>
        );
    }

    _renderHeader() {
        return (<nav className="navbar-sub-sectionName navbar navbar-sub">
            <div className="container">
                <div className="pull-left">
                    <span className="heading-text">{this.state.content.confirmation.pageTitle}</span>
                    <p className="context-copy" dangerouslySetInnerHTML={{ __html: this.state.content.confirmation[this.state.product.value].pageHeading }}></p>
                </div>
            </div>
        </nav>);
    }

    componentDidMount() {
        ConfirmDetailsStore.addChangeListener(this._onChange);
        DeclarationStore.addChangeListener(this._onChange);
        // Deferring this function until UI has been retrieved
        window.requestAnimationFrame(() => {

            setTimeout(() => {
                ConfirmDetailsActions.setWorkItem();
            }, 1000);
        });
        OmnitureTracking.getTrackingEnabled();
    }

    componentWillUnmount() {
        ConfirmDetailsStore.removeChangeListener(this._onChange);
        DeclarationStore.removeChangeListener(this._onChange);
    }

    _onChange() {
        this.setState(getConfirmDetailsState());
    }

    annuityWillUpdate(nextState) {
        if (Products.isAnnuity(this.state.product.value)) {
            if (nextState.accountNumber) {
                ApplicationActions.getAnnuityQuoteUrl(this.state.product.value, nextState.accountNumber);
            }
            if (nextState.annuityQuoteUrl) {
                window.open(nextState.annuityQuoteUrl);
                Transitions.forwardFromConfirmDetails(this.props.router, { identificationMode: ApplicationConstants.ClientIdentificationModes.ANNUITY_WELCOME });
            }
        }
    }
    
    componentWillUpdate(nextProps, nextState) {
        this.annuityWillUpdate(nextState);
        if (this.state.digitalConsentCheckEnabled != nextState.digitalConsentCheckEnabled && nextState.digitalConsentCheckEnabled) {
            //if user is an adviser, we need to verify the mobile numbers given
            if (window.NOA.userContext.isAdviser) {
                const verificationRequest = DigitalConsentEligibilityHelper.generateVerifyMobileNumberRequest(nextState.formModel.form.yourDetails, nextState.formModel.form.accountType);
                IDVerificationActions.verifyMobileNumbers(verificationRequest);
            } else {
                IDVerificationActions.checkDigitalConsentEligibility();
            }
            return;
        }

        if ((!_.isEqual(this.state.eligibility, nextState.eligibility) && nextState.eligibility.checkComplete)) {
            if (nextState.eligibility.eligible === Eligibility.Eligible){
                //do a save here to generate the application id for netcode.
                ApplicationActions.saveApplication(nextState.product.value, nextState.formModel, nextState.clientIdentificationMode);
                IDVerificationActions.navigateToElectronicSubmissionPage();
                Transitions.forwardFromConfirmDetails(this.props.router, { eligibility: nextState.eligibility.eligible });
                return;
            }
            else {
                if (this.state.application && this.state.application.isApplicationDataNotReadyForFunding) {
                    Transitions.forwardFromConfirmDetails(this.props.router, { isShellAccount: true });
                } else {
                    Transitions.forwardFromConfirmDetails(this.props.router, this.state.clientIdentificationMode);
                }
            }
        }
    }

    submitConfirmDetails() {
        this.reviewApplicationToIncludeWorkItem();
        if (Products.isAnnuity(this.state.product.value)) {
            if (!this.state.accountNumber) {
                const applicationForSubmit = ApplicationHelper.getApplicationWithoutPredictiveSearchAdviceFee(this.state.application);
                ApplicationActions.submitApplication(this.state.product.value, applicationForSubmit);
            }
            else {
                Transitions.forwardFromConfirmDetails(this.props.router, { identificationMode: ApplicationConstants.ClientIdentificationModes.ANNUITY_WELCOME });
            }
        }
        else {
            IDVerificationActions.declarationDisagreed();
            ApplicationActions.getDigitalConsentKillSwitch();
        }
    }

    reviewApplicationToIncludeWorkItem() {
        if (this.state.workItem !== null) {
            ConfirmDetailsActions.updateWorkItemModel({
                fileNote: this.state.workItem.fileNote, 
                confirmDetailsBackFile: this.state.workItem.confirmDetailsBackFile
            });
        }
    }

    goBackToApplicationForm() {
        Transitions.forwardFromConfirmDetails(this.props.router, { editMode: true });
    }

    render() {
        const footerContent = FooterUtil.getContent(this.state.product.value, this.state.content.footer);
        const dockFooterStyle = FooterUtil.adjustViewport();
        const downloadData = DownloadFormsHelper.createDownloadData(this.state);

        return (
            <div className="confirmDetails">
                <div className="mainContent" style={dockFooterStyle}>
                    <NavigationBar
                        backButtonUrl={this.goBackToApplicationForm}
                        product={this.state.product}
                        route={this.props.route.path}
                        moreMenuContent={this.state.content.moreMenu}
                        showMoreMenu={this.state.showMoreMenu}
                        application={this.state.application}
                        clientIdentificationMode={this.state.clientIdentificationMode}
                        showDownloadMenu={this.state.showDownloadMenu}
                        accountType={this.state.accountTypeCode}
                        download={downloadData}/>
                    <UserNotification id="userNotificationForInvalidInSpecieScenario" 
                        className="top-sticky-user-notification"
                        message={this.state.content.investmentAllocation.confirmDetails.confirmDetailMessageGotoManualProcess}
                        onClick={this.closeInvalidInSpecieScenarioNotification}
                        hideIcon={false}
                        wrapCopy={false}
                        isHidden={this.state.isInSpecieScenarioValid || this.state.isInSpecieScenarioNotificationClosed} />
                    <UserNotification id="userNotificationForEntitlements" 
                        className="top-sticky-user-notification"
                        message={this.state.content.entitlementAccessNotification}
                        hideIcon={true}
                        wrapCopy={true}
                        isHidden={this.state.canContinue} />
                <div className="nav-spacer"></div>
                    { this._renderHeader() }
                    { this._renderConfirmationSections() }
                    <button className="btn navigationBar navbar navbar-success confirmDetails__submit" id="review-and-confirm" onClick={this.submitConfirmDetails} disabled={!this.state.canContinue || !this.state.isInSpecieScenarioValid || this.state.isEmulation}>
                        <div className="container">
                            <div className="pull-left"><h3>Continue</h3></div>
                            <div className="pull-right"><a className="arrow"><i className="icon icon-right-open-big"></i></a></div>
                        </div>
                    </button>
                </div>
                <Footer content={footerContent} />
            </div>);
    }
}

export default withRouter(ConfirmDetails)


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ConfirmDetails.jsx